import { Button, Typography } from "antd";
import { FileTextFilled, EditFilled, DeleteFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

export const useColumnsLeagueGames = (showModal) => {
  const navigate = useNavigate();

  return [
    {
      key: "nameEn",
      title: "English Name",
      dataIndex: "nameEn",
      search: false,
    },
    {
      key: "nameAr",
      title: "Arabic Name",
      dataIndex: "nameAr",
      search: false,
    },
    {
      key: "isEnable",
      title: "Is Active",
      dataIndex: "isEnable",
      render: (record) => (record ? "True" : "False"),
      valueEnum: {
        true: {
          text: "True",
        },
        false: {
          text: "False",
        },
      },
    },
    {
      key: "startTime",
      title: "Started At",
      dataIndex: "startTime",
      valueType: "dateTimeRange",
      search: false,
      fieldProps: {
        placeholder: ["Start time", "End time"],
        showTime: { format: "HH:mm" },
      },
      render: (_, record) => {
        return (
          <Text>
            {dayjs(record.startTime)
              .tz("Asia/Kuwait")
              .format("YYYY/MM/DD HH:mm")
              .toString()}
          </Text>
        );
      },
    },
    {
      key: "endTime",
      title: "Ended At",
      dataIndex: "endTime",
      valueType: "dateTimeRange",
      search: false,
      fieldProps: {
        placeholder: ["Start time", "End time"],
        showTime: { format: "HH:mm" },
      },
      render: (_, record) => {
        return record.endTime ? (
          <Text>
            {dayjs(record.endTime)
              .tz("Asia/Kuwait")
              .format("YYYY/MM/DD HH:mm")
              .toString()}
          </Text>
        ) : (
          "--"
        );
      },
    },
    {
      key: "createdAt",
      title: "Created At",
      dataIndex: "createdAt",
      valueType: "dateTimeRange",
      search: false,
      fieldProps: {
        placeholder: ["Start time", "End time"],
        showTime: { format: "HH:mm" },
      },
      render: (_, record) => {
        return (
          <Text>
            {dayjs(record.createdAt)
              .tz("Asia/Kuwait")
              .format("YYYY/MM/DD HH:mm")
              .toString()}
          </Text>
        );
      },
    },
    {
      key: "actions",
      title: "Actions",
      search: false,
      width: 100,
      render: (_, record) => [
        <div key={record.id} className="actions-wrapper">
          <Button
            className="icon-button"
            icon={<FileTextFilled />}
            onClick={() => navigate(`/league-game/detail/${record?.id}`)}
          />

          <Button
            className="icon-button"
            icon={<EditFilled />}
            onClick={() => navigate(`/league-game/edit/${record?.id}`)}
          />

          {showModal && (
            <Button
              className="icon-button"
              icon={<DeleteFilled />}
              onClick={() => showModal(record)}
            />
          )}
        </div>,
      ],
    },
  ];
};
